import AntCheckbox from 'antd/es/checkbox';

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.scss';

/**
 * Checkbox.
 */
const propTypes = {

}
const Checkbox = ( { className: customClass, ...p } ) => {

  const className = classnames(
    'Checkbox',
    className
  )

  return(

    <AntCheckbox
    className={ className }
    { ...p }
    />

);

};
Checkbox.propTypes = propTypes;

Checkbox.Group = AntCheckbox.Group;

export default Checkbox;
